<div class="scorecard-comparison">
    <div class="comparison-row">
        <!-- Left scorecard -->
        <app-scorecard-item
            [availableFilters]="externalLeft ? [] : availableFilters"
            [filterId]="externalLeft ? null : leftFilterId"
            [data]="externalLeft ? externalLeft.data : leftData"
            [isLoading]="externalLeft ? false : leftLoading"
            [externalLabel]="externalLeft?.label ?? null"
            [accentColor]="externalLeft?.color ?? null"
            [hideFilterSelect]="!allowCompare && !externalLeft"
            (filterSelected)="onLeftFilterSelected($event)"
        />

        <!-- Center controls (only in normal filter mode) -->
        <div *ngIf="allowCompare && !externalLeft" class="comparison-controls">
            <button
                *ngIf="canSwap"
                class="swap-btn text"
                type="button"
                (click)="swapFilters()"
                [title]="'FEATURES.SCORECARD.SWAP' | translate"
            >
                <span class="material-symbols-rounded" aria-hidden="true">swap_horiz</span>
            </button>
            <button class="compare-toggle-btn" [class.active]="showRightCard" type="button" (click)="toggleCompare()">
                <span class="material-symbols-rounded leading" aria-hidden="true">{{
                    showRightCard ? 'remove' : 'add'
                }}</span>
                {{ 'FEATURES.SCORECARD.COMPARE' | translate }}
            </button>
        </div>

        <!-- Right scorecard (normal compare or external bar2) -->
        <app-scorecard-item
            *ngIf="(allowCompare && showRightCard) || externalRight"
            [availableFilters]="externalRight ? [] : availableFilters"
            [filterId]="externalRight ? null : rightFilterId"
            [data]="externalRight ? externalRight.data : rightData"
            [baseData]="externalLeft ? externalLeft.data : leftData"
            [isLoading]="externalRight ? false : rightLoading"
            [externalLabel]="externalRight?.label ?? null"
            [accentColor]="externalRight?.color ?? null"
            (filterSelected)="onRightFilterSelected($event)"
        />

        <!-- Placeholder to keep layout stable when compare is available but hidden -->
        <div *ngIf="allowCompare && !showRightCard && !externalLeft" class="compare-placeholder"></div>
    </div>
</div>
